import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';

/*
 * Superfiliate's tracking script, so affiliate visits landing on our own pages
 * (instead of their cobranded landing pages) are attributed a conversion even
 * when no discount code is used at checkout.
 * @see https://help.superfiliate.com/articles/2185449010-using-superfiliate-with-headless-storefront
 */

// the sdk is keyed to the .myshopify.com domain
const shop = process.env.SHOPIFY_DOMAIN;

// the sdk loads async, so poll for it before registering the page view
const SDK_POLL_INTERVAL = 250;
const SDK_POLL_ATTEMPTS = 40; // give up after 10s

export function Superfiliate() {
  const { asPath } = useRouter();

  // register a page view on first load and on every client side navigation
  useEffect(() => {
    if (!shop) return undefined;

    let attempts = 0;

    const intervalId = setInterval(() => {
      attempts += 1;
      const sdk = window.$superfiliateStorefront?.sdk;

      if (sdk?.handlePageView) {
        clearInterval(intervalId);
        sdk.handlePageView();
      } else if (attempts >= SDK_POLL_ATTEMPTS) {
        clearInterval(intervalId);
      }
    }, SDK_POLL_INTERVAL);

    return () => clearInterval(intervalId);
  }, [asPath]);

  if (!shop) return null;

  return (
    <Script
      id="superfiliate-script"
      type="text/javascript"
      src={`https://superfiliate-cdn.com/storefront.js?shop=${shop}`}
      strategy="afterInteractive"
    />
  );
}
